import { Skeleton } from "@mui/material";
import { usePensionBanner } from "@repo/logic";
import { PensionBanner } from "@repo/ui";
import { type FC } from "react";
import { useContracts } from "../../queryHooks";

export const PensionBannerWrapper: FC = () => {
    const contractsQuery = useContracts();
    const { showBanner, isLoading } = usePensionBanner(contractsQuery);

    if (isLoading) return <Skeleton variant="rounded" height="128px" width="100%" />;

    if (!showBanner) return null;

    return <PensionBanner />;
};
